export enum TYPE_RESULTS {
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

interface Props {
  type?: TYPE_RESULTS
  size?: number
}

export const ResultIcon = ({ type, size = 52 }: Props) => {
  switch (type) {
    case TYPE_RESULTS.SUCCESS:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 50 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 50.667C38.8071 50.667 50 39.4741 50 25.667C50 11.8599 38.8071 0.666992 25 0.666992C11.1929 0.666992 0 11.8599 0 25.667C0 39.4741 11.1929 50.667 25 50.667ZM36.4801 19.3182C37.1158 18.5008 36.9686 17.3228 36.1512 16.687C35.3338 16.0513 34.1557 16.1985 33.52 17.0159L23.5025 29.8956C23.2797 30.182 22.8607 30.2192 22.591 29.9764L16.2543 24.2734C15.4846 23.5807 14.2991 23.6431 13.6063 24.4128C12.9136 25.1825 12.976 26.368 13.7457 27.0608L20.0824 32.7638C21.9702 34.4628 24.9033 34.2027 26.4625 32.1979L36.4801 19.3182Z"
            fill="#5BAAFF"
          />
        </svg>
      )
    case TYPE_RESULTS.ERROR:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28 0C12.5563 0 0 12.5563 0 28C0 43.4437 12.5563 56 28 56C43.4437 56 56 43.4437 56 28C56 12.5563 43.4437 0 28 0Z"
            fill="#F05A5A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.9421 37.9424C37.264 38.6205 36.1483 38.6205 35.4702 37.9424L27.9999 30.4721L20.5405 37.9424C19.8624 38.6205 18.7468 38.6205 18.0687 37.9424C17.3905 37.2643 17.3905 36.1486 18.0687 35.4705L25.539 28.0111L18.0687 20.5518C17.3905 19.8736 17.3905 18.758 18.0687 18.0799C18.7468 17.4018 19.8624 17.4018 20.5405 18.0799L27.9999 25.5393L35.4593 18.0799C36.1374 17.4018 37.253 17.4018 37.9312 18.0799C38.6093 18.758 38.6093 19.8736 37.9312 20.5518L30.4718 28.0002L37.9312 35.4596C38.6202 36.1486 38.6202 37.2533 37.9421 37.9424Z"
            fill="white"
          />
        </svg>
      )
    case TYPE_RESULTS.WARNING:
    default:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 0C11.1899 0 0 11.1899 0 25C0 38.8101 11.1899 50 25 50C38.8101 50 50 38.8101 50 25C50 11.1899 38.8101 0 25 0ZM26.3702 37.9087C26.0096 38.2332 25.5048 38.5096 25 38.4615C23.9904 38.4856 23.0048 37.5601 23.0769 36.5385C23.0529 35.4808 23.8942 34.6034 24.9639 34.5793C26.0216 34.5433 26.9712 35.4808 26.9231 36.5385C26.9111 37.0433 26.7187 37.5361 26.3702 37.9087ZM26.9231 28.8462C26.9231 29.9038 26.0577 30.7692 25 30.7692C23.9423 30.7692 23.0769 29.9038 23.0769 28.8462V17.3077C23.0769 16.25 23.9423 15.3846 25 15.3846C26.0577 15.3846 26.9231 16.25 26.9231 17.3077V28.8462Z"
            fill="#EFAF0C"
          />
        </svg>
      )
  }
}
